"use client";

import { ReportParentContentEnum } from "@/app/types/typeConfig/report";
import { useTranslations } from "@/app/lib/LocaleProvider";
import { AIFooter } from "@/app/components/robot/components/AIFooterShared";
import { IMConfigTypeEnum } from "@/app/types/typeConfig/chatQuestion";

interface TechAIFooterProps {
  uniqueKey?: string;
  data: {
    parentContentInfo?: {
      parentContentId?: string;
      parentContent?: string;
      parentContentType?: ReportParentContentEnum;
    };
    [key: string]: unknown;
  };
  aiTypingEnd?: boolean;
  error?: boolean;
  showSubmitTicket?: boolean;
  artificialStop?: boolean;
  showTechAIFooter?: boolean;
  requestId?: string;
  content?: string;
  onStop?: () => void;
  onRedo?: () => void;
  onLike?: () => void;
  onDislike?: () => void;
  streamingId?: string;
}

/**
 * AI 消息底部栏（TechAI）：统一使用 AIFooter，仅传入 TechAI 场景的 config、文案与显隐逻辑。
 */
export default function TechAIFooter({
  data,
  error = false,
  showSubmitTicket = true,
  showTechAIFooter = true,
  requestId,
  content,
  streamingId,
  aiTypingEnd,
  onRedo,
  onLike,
  onDislike,
}: TechAIFooterProps) {
  const t = useTranslations();

  return (
    <AIFooter
      data={data}
      requestId={requestId}
      content={content}
      configType={IMConfigTypeEnum.techAiFAQ}
      onLike={onLike}
      onDislike={onDislike}
      showFooter={showTechAIFooter}
      streamingId={streamingId}
      showActions={showSubmitTicket && !error}
      showCopy={!!(content && aiTypingEnd)}
      showSatisfy={
        !!(content && aiTypingEnd) &&
        (data as { aiFlag?: boolean }).aiFlag === true
      }
      statusType={error ? "error" : "normal"}
      statusText={error ? t.chat.AISuspended : t.chat.AIProvided}
      onRedo={onRedo}
    />
  );
}
